import React, { useState } from 'react';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/ext-language_tools';

const JsonCodeEditor = ({ initialCode, onUpdate }) => {
  const [code, setCode] = useState(initialCode);
  const [isLoading, setIsLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);

  const onChange = (newValue) => {
    setCode(newValue);
  };

  const onValidate = (annotations) => {
    const errors = annotations.filter(a => a.type === 'error');
    if (errors.length > 0) {
      console.log('JSON Validation Errors:', errors);
    }
  };

  const handleUpdate = async () => {
    setIsLoading(true);
    setApiResponse(null);
    const result = await onUpdate(code);
    setApiResponse(result);
    setIsLoading(false);
  };

  const buttonStyle = {
    width: '100%',
    padding: '12px 20px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: isLoading ? '#f87171' : '#ef4444',
    border: 'none',
    borderRadius: '8px',
    cursor: isLoading ? 'not-allowed' : 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  };

  const buttonHoverStyle = {
    backgroundColor: '#dc2626',
    boxShadow: '0 6px 8px rgba(0, 0, 0, 0.15)',
    transform: 'translateY(-2px)',
  };

  return (
    <div style={{
      width: '100%',
      maxWidth: '64rem',
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
    }}>
      <div style={{ backgroundColor: '#111827', padding: '12px' }}>
        <AceEditor
          mode="json"
          theme="monokai"
          onChange={onChange}
          onValidate={onValidate}
          value={code}
          name="json-editor"
          editorProps={{ $blockScrolling: true }}
          setOptions={{
            useWorker: false,
            showLineNumbers: true,
            tabSize: 2,
          }}
          style={{ width: '100%', height: '55vh' }}
        />
      </div>
      <div style={{ padding: '16px', backgroundColor: '#f9fafb' }}>
        <button
          onClick={handleUpdate}
          disabled={isLoading}
          style={buttonStyle}
          onMouseEnter={(e) => {
            if (!isLoading) {
              Object.assign(e.target.style, buttonHoverStyle);
            }
          }}
          onMouseLeave={(e) => {
            if (!isLoading) {
              Object.assign(e.target.style, buttonStyle);
            }
          }}
        >
          {isLoading ? 'Updating...' : 'Update'}
        </button>
        {apiResponse && (
          <div style={{
            marginTop: '12px',
            padding: '10px',
            borderRadius: '4px',
            backgroundColor: apiResponse.success ? '#d1fae5' : '#fee2e2',
            color: apiResponse.success ? '#047857' : '#b91c1c',
          }}>
            <p style={{ fontWeight: '600' }}>{apiResponse.message}</p>
            {!apiResponse.success && apiResponse.error && (
              <pre style={{
                marginTop: '8px',
                fontSize: '14px',
                overflowX: 'auto',
              }}>
                {JSON.stringify(apiResponse.error, null, 2)}
              </pre>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default JsonCodeEditor;